import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = `Candidates|System Activity|Log`;

export type CandidateLogLocs = 'SPCandidateLogExamEditRegistrationLink';

const sharedLocProperties: Pick<LocDef, 'htmlAllowed' | 'shared' | 'portal' | 'feature'> = {
	htmlAllowed: false,
	shared: false,
	portal: 'SP',
	feature: HubFeature.Exam,
};

export const spCandidateLogLocs: LocDefs<CandidateLogLocs> = {
	SPCandidateLogExamEditRegistrationLink: {
		...sharedLocProperties,
		defaultValue: 'Registration number',
		description: 'Label text for the exam link',
		displayPath: `${dpRoot}|Exam Registration Link`,
		displayType: 'Content',
		legacyName: 'Core/Candidates.Log.Content.ViewExam',
	},
};

export const LOC_KEYS = MapLocKeys<CandidateLogLocs>(spCandidateLogLocs);
